import React from 'react';
import { Typography } from '@mui/material';
import styles from './styles';

function Status({ styleProp, children }) {
  return (
    <Typography sx={{ ...styles.item, ...styleProp }}>{children}</Typography>
  );
}

export default Status;
